const loyalTypes = {
    LA_GET_DATA_PENDING: "LA_GET_DATA_PENDING",
    LA_GET_DATA_SUCCESS: "LA_GET_DATA_SUCCESS",
    LA_GET_DATA_ERROR: "LA_GET_DATA_ERROR",


    LA_CHANGE_DATA_PERIOD: "LA_CHANGE_DATA_PERIOD"
}

export default loyalTypes